export const inputRowCommonStyles = {
  padding: "5px",
};

export const submitbtnRowCommonStyles = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "1rem",
};
